<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          ข้อเสนอโครงการ
        </div>
        <div class="d-flex align-center">
          <Iconify
              icon="icon-park-solid:inbox-download-r"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          <div v-if="isUSP">โครงการที่ส่งยื่น</div>
          <div v-if="isRSP">โครงการที่รับส่งยื่น</div>
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 190px">
            <div>สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in (isRSP ? tableHeaderRSP : tableHeader)"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <PlanOfferItem
            v-for="(item, i) in plans"
            :key="i"
            :item="item"
            :index="i"
            :headers="isRSP ? tableHeaderRSP : tableHeader"
            @onUpdateStatus="(status) => onUpdateStatus(status, item.id)"
        ></PlanOfferItem>
      </div>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SelectBox from "../../components/input/SelectBox"
import PlanOfferItem from "../../components/PlanOfferItem"
import { mapState } from "vuex"

export default {
  name: "PlanOfferList",
  components: {
    TextField,
    SelectBox,
    PlanOfferItem
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'รหัสโครงการ',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการ',
          width: '27%'
        },
        {
          name: 'เเผนงานที่ยื่น',
          width: '27%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '13%'
        },
        {
          name: 'สถานะ',
          width: '13%'
        }
      ],
      tableHeaderRSP: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '5%'
        },
        {
          name: 'รหัสโครงการ',
          width: '7%'
        },
        {
          name: 'ชื่อโครงการ',
          width: '20%'
        },
        {
          name: 'เเผนงาน',
          width: '20%'
        },
        {
          name: 'รอบที่',
          width: '6%'
        },
        {
          name: 'มหาวิทยาลัย',
          width: '10%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '10%'
        },
        {
          name: 'สถานะ',
          width: '16%'
        }
      ],
      plans: [
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'ฉบับร่าง'
        // },
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'รอพิจารณา'
        // },
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'ไม่ผ่านพิจารณา'
        // }
      ]
    }
  },
  created () {
    this.getFormCList()
  },
  computed: {
    ...mapState({
      isUSP: state => state.Auth.User.user_type === 'USP',
      isRSP: state => state.Auth.User.user_type === 'RSP'
    })
  },
  methods: {
    async getFormCList () {
      let res
      let payload = {
        status: 'Draft,Submitted1,Reject'
      }

      if (this.isRSP) payload.status = 'Submitted1,Inception,Submitted2'

      res = await this.$apiFire('CForm/getFormCList', payload)
      console.log(res)
      this.plans = res
    },
    async onUpdateStatus (status, id) {
      let payload = {
        id,
        payload: {
          status
        }
      }

      let res = await this.$apiFire('CForm/updateFormCStatus', payload)
      this.getFormCList()
    }
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>